import {
    Component,
    OnInit,
    ElementRef,
    ViewChild,
    AfterViewInit,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router, NavigationEnd } from "@angular/router";
import { Location } from "@angular/common";

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit, AfterViewInit {
    @ViewChild("footerRef") footerRef!: ElementRef;

    location: any;
    footerClass: any;
    email: string = "";
    subscribeUrl = "https://condor3676.startdedicated.com:8005/subscribe/";
    subscriptionStatus: string = "";

    constructor(
        private router: Router,
        location: Location,
        private http: HttpClient
    ) {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.location = this.router.url;
                if (
                    [
                        "/home-two",
                        "/home-four",
                        "/services-details",
                        "/events-details",
                        "/courses",
                        "/courses-details",
                    ].includes(this.location)
                ) {
                    this.footerClass = "footer-area";
                } else if (this.location === "/about-us") {
                    this.footerClass = "footer-area bg-fffaf3";
                } else {
                    this.footerClass = "footer-area bg-color";
                }
            }
        });
    }

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        const element = this.footerRef.nativeElement;
                        const bg = element.getAttribute("data-bg");
                        if (bg) {
                            element.style.backgroundImage = `url(${bg})`;
                        }
                        observer.disconnect();
                    }
                },
                { threshold: 0.1 }
            );

            observer.observe(this.footerRef.nativeElement);
        } else {
            // Fallback if IntersectionObserver is not supported
            const element = this.footerRef.nativeElement;
            const bg = element.getAttribute("data-bg");
            if (bg) {
                element.style.backgroundImage = `url(${bg})`;
            }
        }
    }

    onEmailChange(event: any): void {
        this.email = event.target.value;
    }

    subscribe(): void {
        if (!this.email || !this.validateEmail(this.email)) {
            this.subscriptionStatus = "Please enter a valid email address";
            return;
        }

        this.http.post(this.subscribeUrl, { email: this.email }).subscribe({
            next: () => {
                this.subscriptionStatus = "Successfully subscribed!";
                this.email = "";
            },
            error: (error) => {
                this.subscriptionStatus =
                    "Error subscribing. Please try again.";
                console.error("Subscription error:", error);
            },
        });
    }

    validateEmail(email: string): boolean {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    }
}
